export const API_LOCATION_URL = import.meta.env.VITE_API_URL ?? '';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? '';
